import { api_trade_stats } from './utils';
import type { SeasonIdentifiers } from '$lib/types/tradingRewards';

export async function fetchEstimatedAccruedRewards(address: string) {
	if (!address) return;
	const response = await api_trade_stats(
		'get',
		`snx-trading-season/estimated-accrued-rewards?account=${address}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchEstimatedTradingReward(fee: string) {
	if (!fee) return;
	const response = await api_trade_stats(
		'get',
		`snx-trading-season/estimated-trading-reward?tradingFee=${fee}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchTradingSeasonConfig(seasonIdentifier: SeasonIdentifiers) {
	if (!seasonIdentifier) return;
	const response = await api_trade_stats('get', `trading-seasons/${seasonIdentifier}`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchTradingSeasonStats(seasonIdentifier: SeasonIdentifiers) {
	if (!seasonIdentifier) return;
	const response = await api_trade_stats('get', `trading-seasons/${seasonIdentifier}/season-stats`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchUserTradingSeasonStats(
	seasonIdentifier: SeasonIdentifiers,
	address: string
) {
	if (!seasonIdentifier || !address) return;
	const response = await api_trade_stats(
		'get',
		`trading-seasons/${seasonIdentifier}/stats?account=${address}`
	);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchUserMysteryOrbs(address: string) {
	const response = await api_trade_stats('get', `mystery-orbs/${address}`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function handleClaimOrbApiCall(orbId: string, account: string, signedMessage: string) {
	const response = await api_trade_stats('post', `mystery-orbs/claim`, {
		orbId,
		account,
		signedMessage
	});

	if (response.status !== 201) {
		throw new Error('Something went wrong!');
	}
}

export async function validateAddressForNewYearOrb(scwAddress: string) {
	const response = await api_trade_stats('get', `mystery-orbs/new-year-orb/${scwAddress}`);

	if (response.status === 200) {
		const data = await response.json();
		return data as any;
	}
}

export async function handleClaimLevelNftApiCall(account: string, level: number) {
	const response = await api_trade_stats(
		'get',
		`trading-seasons/season-2/nft-mint-data?level=${level}&account=${account}`
	);

	if (response.status === 200) {
		const data: { account: string; data: string; level: number; nftId: number } =
			await response.json();
		return data;
	} else {
		throw new Error('Failed to fetch NFT mint data');
	}
}

export async function fetchUserPolyPoints(address: string) {
	const response = await api_trade_stats('get', `poly-points/${address}`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchAllCompetitions() {
	const response = await api_trade_stats('get', `trading-competitions`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}

export async function fetchUserActivity(address: string) {
	const response = await api_trade_stats('get', `trading-seasons/season-2/${address}/activity`);

	if (response.status === 200) {
		const data = await response.json();
		return data;
	}
}
